import { create } from 'zustand'

interface Gap {
  horizontal: number
  vertical: number
}

export const DEFAULT_PAGE_SIZE = {
  label: 'A4',
  widthMM: 210,
  heightMM: 297
}

interface PrintGridState {
  gap: Gap
  setGap: (gap: Partial<Gap>) => void
  tableCardsPerPage: number
  setTableCardsPerPage: (value: number) => void
  landscapeMode?: boolean
  setLandscapeMode: (value: boolean) => void
  reset: () => void
}

export const usePrintGridStore = create<PrintGridState>(set => ({
  gap: {
    horizontal: 0,
    vertical: 0
  },
  setGap: gap =>
    set(state => ({
      gap: { ...state.gap, ...gap }
    })),

  tableCardsPerPage: 1,
  setTableCardsPerPage: (value: number) =>
    set(() => ({
      tableCardsPerPage: value
    })),

  landscapeMode: undefined,
  setLandscapeMode: value =>
    set(() => ({
      landscapeMode: value
    })),

  reset: () =>
    set({
      gap: { horizontal: 0, vertical: 0 },
      tableCardsPerPage: 1
    })
}))
